module.exports = __webpack_public_path__ + "img/menu-auto.23c20cc.svg";